import { environment } from 'src/environments/environment';

export const ApiEndpoints = {
    core: {
        auth: {
            login: () => `${environment.serverUrl}/authenticate`,
            loginWithBusinessEntity: () => `${environment.serverUrl}/authenticate/login`,
            userEntities: () => `${environment.serverUrl}/authenticate/user-entities`,
            validate: () => `${environment.serverUrl}/authenticate/token/`,
            get: () => `${environment.serverUrl}/authenticate/user/`,
            logout: () => `${environment.serverUrl}/logout/`,
            redirectAT: (returnUrl: string) => `${environment.serverUrl}/protocoled/redirect-to-at?returnUrl=` + returnUrl,
            loginAT: () => `${environment.serverUrl}/protocoled/authenticate`,
        },
        menu: {
          get: () => `${environment.serverUrl}/menuEntry/menu/`,
          getRegular: () => `${environment.serverUrl}/menuEntry/menu/regular`,
          getAdmin: () => `${environment.serverUrl}/menuEntry/menu/admin`,
          saveMenuConfiguration: () => `${environment.serverUrl}/menuEntry/configuration`,
          getMenuConfiguration: () => `${environment.serverUrl}/menuEntry/configuration`,
          post: () => `${environment.serverUrl}/menuEntry/`,
          put: () => `${environment.serverUrl}/menuEntry/`,
          delete: (id, versionNumber) => `${environment.serverUrl}/menuEntry/${id}/${versionNumber}`
        },
        notification: {
            getAll: () => `${environment.serverUrlNotifier}/notification/`,
            read: (id) => `${environment.serverUrlNotifier}/notification/mark-as-read/${id}`,
            unread: () => `${environment.serverUrlNotifier}/notification/unread`,
            archive: () => `${environment.serverUrlNotifier}/notification/bulk-operation`,
            restore: () => `${environment.serverUrlNotifier}/notification/restore`,
            count: () => `${environment.serverUrlNotifier}/notification/user/count`,
            get: (id: any) => `${environment.serverUrlNotifier}/notification/${id}`,
            revisions: () => `${environment.serverUrlNotifier}/notification/revisions`,
            search: () => `${environment.serverUrlNotifier}/notification/user`,
            post: () => `${environment.serverUrlNotifier}/notification/`,
            put: () => `${environment.serverUrlNotifier}/notification/`,
            delete: (id: any, versionNumber: any) => `${environment.serverUrlNotifier}/notification/${id}/${versionNumber}`
        },
        task: {
            getAll: () => `${environment.serverUrlNotifier}/task/`,
            read: (id) => `${environment.serverUrlNotifier}/task/mark-as-read/${id}`,
            unread: () => `${environment.serverUrlNotifier}/task/unread`,
            archive: () => `${environment.serverUrlNotifier}/task/bulk-operation`,
            restore: () => `${environment.serverUrlNotifier}/task/restore`,
            count: () => `${environment.serverUrlNotifier}/task/user/count`,
            get: (id: string) => `${environment.serverUrlNotifier}/task/${id}`,
            revisions: () => `${environment.serverUrlNotifier}/task/revisions`,
            search: () => `${environment.serverUrlNotifier}/task/user`,
            post: () => `${environment.serverUrlNotifier}/task/`,
            put: () => `${environment.serverUrlNotifier}/task/`,
            delete: (id: string, versionNumber: any) => `${environment.serverUrlNotifier}/task/${id}/${versionNumber}`
        },
        deputy: {
            get: (userId) => `${environment.serverUrl}/deputy/substitute/${userId}`,
            getPossibleSubstitutes: () => `${environment.serverUrl}/deputy/possibilities`,
        },
        impersonalization: {
          getImpersonalizationList: () => `${environment.serverUrl}/impersonalization/business-entities/`,
          getUsersList: (businessEntityId) => `${environment.serverUrl}/impersonalization/${businessEntityId}/possibilities/`,
          get: (username, businessEntityId) => `${environment.serverUrl}/impersonalization/impersonalize/${businessEntityId}/${username}`,
        },
        user_general_data: {
          get: (id) => `${environment.serverUrl}/user-general-data/${id}`,
          getPhoto: (id) => `${environment.serverUrl}/user/${id}/photo`,
          public: () => `${environment.serverUrl}/user-general-data/public`,
          search: () => `${environment.serverUrl}/user-general-data/search`,
          screensearch: () => `${environment.serverUrl}/user-general-data/screen-search`,
          post: () => `${environment.serverUrl}/user-general-data/`,
          postComplete: () => `${environment.serverUrl}/user-general-data/user-registration-complete`,
          put: () => `${environment.serverUrl}/user-general-data/`,
          delete: (id, versionNumber) => `${environment.serverUrl}/user-general-data/${id}/${versionNumber}`,
          block: (id, versionNumber) => `${environment.serverUrl}/user-general-data/${id}/${versionNumber}/block/`,
          activate: (id, versionNumber) => `${environment.serverUrl}/user-general-data/${id}/${versionNumber}/activate/`,
        },
        notifier: {
          notification_template: {
            get: (id) => `${environment.serverUrlNotifier}/notification-template/${id}`,
            search: () => `${environment.serverUrlNotifier}/notification-template/search`,
            post: () => `${environment.serverUrlNotifier}/notification-template/`,
            init: () => `${environment.serverUrlNotifier}/notification-template/init`,
            put: () => `${environment.serverUrlNotifier}/notification-template/`,
            delete: (id, versionNumber) => `${environment.serverUrlNotifier}/notification-template/${id}/${versionNumber}`
          },
          event_configuration: {
            get: (id) => `${environment.serverUrlNotifier}/event-configuration/${id}`,
            search: () => `${environment.serverUrlNotifier}/event-configuration/search`,
            post: () => `${environment.serverUrlNotifier}/event-configuration/`,
            put: () => `${environment.serverUrlNotifier}/event-configuration/`,
            delete: (id, versionNumber) => `${environment.serverUrlNotifier}/event-configuration/${id}/${versionNumber}`
          },
        }
    },
    master_data: {
      timezone: {
        get: () => `${environment.serverUrlMD}/timezone/system-locations-timezone`,
      }
    },
    gad: {
      user_token: {
        get: () => `${environment.serverUrl}/user-token/has-many-active`,
        getAlerts: () => `${environment.serverUrl}/user-token/has-alerts`,
      }
    }
};
